// import { nativeTokenName } from "src/constants";
import { Box, Divider, Typography, makeStyles } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import moment from "moment";
import axios from "axios";
// import ApiConfig from "src/Apiconfigs/config";
const useStyles = makeStyles((theme) => ({
  tablemainbox: {
    "& .activitysub": {
      padding: "20px",
      borderBottom: "1px solid #3A3939",
      "& svg": {
        fontSize: "20px",
      },
      "& h5": {
        fontWeight: "600",
        marginLeft: "10px",
      },
    },
    "& .apexcharts-menu-item": {
      color: theme.palette.text.primary.main,
    },
  },
}));

const PriceHistory = ({ data, selectedDuration }) => {
  const [graphPoints, setGraphPoints] = useState({
    points: [],
    time: [],
  });

  const state = {
    series: [
      {
        name: "Page Views",
        data: [0.0204, 0.0206, 0.0208, 0.021, 0.0212],
      },
      //   {
      //     name: "Page Views",
      //     data: [0.0204, 0.0206, 0.0208, 0.021, 0.0212],
      //   },
    ],
    options: {
      chart: {
        foreColor: "rgba(255, 255, 255, 0.6)",

        zoom: {
          enabled: true,
          type: "x",
          autoScaleYaxis: false,
          zoomedArea: {
            fill: {
              color: "#90CAF9",
              opacity: 0.4,
            },
            stroke: {
              color: "#0D47A1",
              opacity: 0.4,
              width: 1,
            },
          },
        },
        height: 100,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
        color: "none",
      },
      grid: {
        borderColor: "transparent",
      },
      yaxis: {
        overwriteCategories: [0.0, 0.1, 0.2],
        tickAmount: 2,
        left: {
          enabled: true,
          drawGridLines: false,
          axisLineWidth: 0,
        },
        right: {
          drawGridLines: false,
          axisLineWidth: 0,
          enabled: false,
        },
      },

      tooltip: {
        enabled: true,
        followCursor: true,
        theme: "dark",
      },
      colors: ["#FF136D"],
    },
  };
  const classes = useStyles();

  return (
    <Box className={classes.tablemainbox}>
      <Box p={1}>
        <ReactApexChart
          options={state.options}
          series={state.series}
          type="line"
          height={250}
        />
      </Box>
    </Box>
  );
};

export default PriceHistory;
